import {
  LocationApi,
  LocationRead,
  LocationsGetCollection200Response,
} from '@/api';
import { State } from '@/store/index';
import axios, { AxiosResponse } from 'axios';
import { Module } from 'vuex';

function getLocationApi(): LocationApi {
  return new LocationApi(undefined, import.meta.env.VITE_PROXY_URL, axios);
}

const getDefaultState = () => ({
  locations: [] as LocationRead[],
  allLocations: [] as LocationRead[],
  locationsPromise: Promise.resolve({} as AxiosResponse) as Promise<
    AxiosResponse<LocationsGetCollection200Response>
  >,
});

export type locationsState = ReturnType<typeof getDefaultState>;

export const Locations: Module<locationsState, State> = {
  namespaced: true,

  state: getDefaultState(),

  mutations: {
    setLocations(
      state: locationsState,
      response: LocationsGetCollection200Response,
    ) {
      state.locations = response['hydra:member'].filter((loc) => loc.available);
      state.allLocations = response['hydra:member'];
    },
    setPromise(
      state: locationsState,
      promise: Promise<AxiosResponse<LocationsGetCollection200Response>>,
    ) {
      state.locationsPromise = promise;
    },
  },

  actions: {
    async fetchLocations({ commit, state }) {
      const locationApi = getLocationApi();
      commit('setPromise', locationApi.locationsGetCollection({}));
      const response = await state.locationsPromise;
      commit('setLocations', response.data);
    },
  },
};
